import { render, staticRenderFns } from "./VerifyScreeningNotices.vue?vue&type=template&id=75dfd234&scoped=true&"
import script from "./VerifyScreeningNotices.vue?vue&type=script&lang=js&"
export * from "./VerifyScreeningNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dfd234",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VSlideYReverseTransition})
